/**
 * Helpers to get default contents by item resource type
 */
/* eslint import/order: ["warn", {"newlines-between": "always-and-inside-groups"}] */
import {
    getImageInfo,
    getImageAspectRatio,
    getViewportResolution,
    getCoverImageInfo,
    getIngressImageInfo,
    constructImageSrc,
    getImageUrl
} from '@/helpers/image.js';

import {
    getCanvasXStep
} from '@/helpers/masonry.js';


/**
 * Returns default ingress image for each resource type.
 */
export const getDefaultImageSrc = function (item) {
    if (!item) {
        return '';
    }
    const href = (item._links && item._links.self && item._links.self.href) || '';

    // Actors --- uses MissingImage param
    // mix with one of artist's artworks as background?
    // if (item.ActorType || href.match('actors')) {
    //     const n = _.random(1, 2);
    //     // select image based on current color theme
    //     // EDIT: not, as the image background is now white, and also the home page
    //     //       with gray background gets messed up
    //     // if (getTheme() === "dark") {
    //     //     return require(`assets/images/actor-not-found_white-${n}.png`);
    //     // }
    //     return require(`assets/images/actor-not-found-${n}.png`);
    // }

    // Collections ---
    if (href.match('collections')) {
        return `/svc/collections/${item.Id}/images/ingressimage`;
    }

    // Organizations ---
    else if (href.match('organizations')) {
        return `/svc/organizations/${item.Id}/images/ingressimage`;
    }

    // Events ---
    else if (href.match('events')) {
        return `/svc/events/${item.Id}/images/ingressimage`;
    }
};


/**
 * Get resource CoverImage.
 */
export const getCoverImageSrc = function (item, imageAttrs) {
    let imageUrl;
    if (item) {
        // try different ways to deduce the cover image
        const coverImageInfo = getCoverImageInfo(item);
        if (coverImageInfo && coverImageInfo.Url) {
            imageUrl = coverImageInfo.Url;
        }
        else if (item._links && item._links.coverimage && item._links.coverimage.href) {
            imageUrl = item._links.coverimage.href;
        }
        // audio
        else if (item.AudioPlayer && item.AudioPlayer.CoverImageUrl) {
            // player.CoverImageInfo is included in coverImageInfo
            imageUrl = item.AudioPlayer.CoverImageUrl;
        }
        // video
        else if (item.VideoPlayer) {
            // no thumbnail image here from external video service,
            // as it could be very large and hog the client network and jam the browser
            //
            //     if (player.VideoInfo && player.VideoInfo.ThumbnailUrl) {
            //         imageUrl = player.VideoInfo.ThumbnailUrl;
            //     }

            const player = item.VideoPlayer;
            // player.CoverImageInfo is included in coverImageInfo
            if (player.CoverImageUrl) {
                imageUrl = player.CoverImageUrl;
            }
            else {
                imageUrl = `/svc/videos/${item.Id}/images/coverimage`;
            }
        }
    }

    // TODO: refactor this to use the fn
    // else {
    //     imageUrl = getDefaultImageSrc(item);
    // }
    //
    if (!imageUrl && item) {
        // use default resource path
        const href = (item._links && item._links.self && item._links.self.href) || '';

        // Collections ---
        if (href.match('collections')) {
            imageUrl = `/svc/collections/${item.Id}/images/coverimage`;
        }

        // Organizations ---
        else if (href.match('organizations')) {
            imageUrl = `/svc/organizations/${item.Id}/images/coverimage`;
        }

        // Actors ---
        else if (href.match('actors')) {
            imageUrl = `/svc/actors/${item.Id}/images/coverimage`;
        }

        // Events ---
        // else if (href.match('events')) {
        //     imageUrl = `/svc/events/${item.Id}/images/coverimage`;
        // }

        // Artworks ---
        else if (href.match('artwork')) {
            // try ImageInfo
            const imageInfo = getImageInfo(item);
            if (imageInfo && imageInfo.Url) {
                imageUrl = imageInfo.Url;
            }
        }

        // Videos ---
        else if (href.match('videos')) {
            imageUrl = `/svc/videos/${item.Id}/images/coverimage`;
        }
    }

    if (!imageUrl) {
        return '';
    }
    else if (imageUrl.match('data:image')) {
        return imageUrl;
    }
    else if (imageUrl.match(/^http/)) {
        return imageUrl;
    }
    else if (imageUrl.match('static')) {
        return imageUrl;
    }

    if (imageUrl.match('data:image')) {
        return imageUrl;
    }

    // set default canvas X
    const resolution = (imageAttrs && imageAttrs.resolution) || {x: '100vw'};

    const attrs = _.extend({
        zoom: null,
        viewerZoom: null,
        ratio: null,
        missingImage: 'Redirect'
    }, imageAttrs, {resolution});

    return constructImageSrc(imageUrl, attrs);
};


/**
 * Get item ingress image by trying various ways.
 */
export const getIngressImageSrc = function (item, imageAttrs) {
    let imageUrl;
    if (item) {
        // try different ways to deduce the ingress image
        const ingressImageInfo = getIngressImageInfo(item);
        if (ingressImageInfo && ingressImageInfo.Url) {
            imageUrl = ingressImageInfo.Url;
        }
        else if (item.IngressImageUrl) {
            imageUrl = item.IngressImageUrl;
        }
        else if (item._links && item._links.ingressimage && item._links.ingressimage.href) {
            imageUrl = item._links.ingressimage.href;
        }

        // audio
        else if (item.AudioPlayer && item.AudioPlayer.IngressImageUrl) {
            // player.IngressImageInfo is included in ingressImageInfo
            imageUrl = item.AudioPlayer.IngressImageUrl;
        }
        // video
        else if (item.VideoPlayer) {
            // no thumbnail image here from external video service,
            // as it could be very large and hog the client network and jam the browser
            //
            //     if (player.VideoInfo && player.VideoInfo.ThumbnailUrl) {
            //         imageUrl = player.VideoInfo.ThumbnailUrl;
            //     }

            const player = item.VideoPlayer;
            // player.IngressImageInfo is included in ingressImageInfo
            if (player.IngressImageUrl) {
                imageUrl = player.IngressImageUrl;
            }
            else {
                imageUrl = `/svc/videos/${item.Id}/images/ingressimage`;
            }
        }
        else {
            imageUrl = getDefaultImageSrc(item);
        }
    }

    if (!imageUrl) {
        return '';
    }
    else if (imageUrl.match('data:image')) {
        return imageUrl;
    }
    else if (imageUrl.match(/^http/)) {
        return imageUrl;
    }
    else if (imageUrl.match('static')) {
        return imageUrl;
    }

    const attrs = _.extend({
        zoom: null,
        viewerZoom: null,
        ratio: null,
        missingImage: 'Redirect'
    }, imageAttrs);

    return constructImageSrc(imageUrl, attrs);
};


/**
 * Article ingress image might come from first ImagePart or _links.ingressimage.
 * FIXME: getCoverImageSrc works better in FeatureArticleTable
 * FIXME: use imageAttrs param
 */
export const getArticleIngressImageSrc = function (item, resolution) {
    if (!item) {
        return null;
    }
    let src = '';
    if (item.IngressImageInfo?.Url) {
        src = item.IngressImageInfo.Url;
    }
    if (item._links?.ingressimage?.href) {
        src = item._links.ingressimage.href;
    }
    else if (item._links?.coverimage?.href) {
        src = item._links.coverimage.href;
    }
    else {
        const part = _.head(_.filter(item.Sections, 'ImagePart'));
        if (part?.ImagePart?.Images) {
            src = _.head(part.ImagePart.Images);
        }
    }
    if (!src) {
        return null;
    }

    const attrs = {
        resolution,
        missingImage: 'Image'
    };
    return constructImageSrc(src, attrs);
};


/**
 * Actors have static ingress image url with MissingImage param.
 */
export const getActorIngressImageSrc = function (item, imageAttrs) {
    if (!item) {
        return '';
    }

    const imageUrl = (item.IngressImageInfo?.Url)
        || `/svc/actors/${item.Id || item.ActorId}/images/ingressimage`;

    const attrs = _.extend({
        format: 'png',
        resolution: {x: 280, y: 280, fixed: true},
        zoomMode: 'Fill',
        missingImage: 'Redirect'
    }, imageAttrs);

    return constructImageSrc(imageUrl, attrs);
};


/**
 * User ProfileImage src.
 */
export const getUserProfileImageSrc = function (userProfile, imageAttrs) {
    if (!userProfile) {
        return '';
    }

    const imageUrl = userProfile.ProfileImageInfo?.Url || userProfile.AvatarImageUrl;

    const attrs = _.extend({
        format: 'png',
        resolution: {x: 280, y: 280, fixed: true},
        zoomMode: 'Fill'
    }, imageAttrs);

    return constructImageSrc(imageUrl, attrs);
};


/**
 * Get image source for full screen view.
 * Either limited to ImageInfo.Width or 1800 px.
 */
export const getFullscreenImageSrc = function (item, imageInfo, imageAttrs) {
    if (!item) {
        return null;
    }
    const imageUrl = getImageUrl(item);
    if (!imageUrl) {
        return null;
    }

    const x = imageInfo?.Width || 1800;
    const y = imageInfo?.Height;

    const resolution = _.extend({x}, (imageAttrs && imageAttrs.resolution));
    if (y) {
        resolution.y = y;
        resolution.fixed = true; // special parameter for formatImageSrcParams to maintain aspect ratio
    }

    return constructImageSrc(imageUrl, _.extend({}, imageAttrs, {resolution}));
};


/**
 * Image src for og:image meta tag.
 */
export const getMetaImageSrc = function (item) {
    if (!item) {
        return '';
    }
    const imageUrl = getImageUrl(item);
    if (imageUrl?.match(/^http/)) {
        return imageUrl;
    }
    else if (imageUrl) {
        const attrs = {resolution: {x: 800}, missingImage: 'Redirect'};
        return constructImageSrc(imageUrl, attrs);
    }
};


/**
 * Calculate background-position for given focus point [x, y] on scale of -50 ... 50.
 * Near the edges the position is adjusted closer to the edge, so that at,
 * eg. point of - from top of large banner would not clip part of the focus point itself.
 *
 *        -50  ... -30   move focus closer to the edge
 *        -30  ... +30   pass actual focus point
 *        +30  ... +50   move focus closer to the edge
 *
 * @returns Array [x, y] for css background-position: %
 */
export const getBackgroundPositionByFocusPoint = function (focusPoint) {
    if (focusPoint) {

        // get css background-position % from FocusPoint value -50 ... +50
        const getBgPosFromPointValue = (value) => {

            let pos = value + 50; // translate to percentage 0 ... 100

            // distance from 20 and 80
            // eg. 19% => 19 - 1 = 18%
            //     15% => 15 - 5 = 10%
            //     85% => 85 + 5 = 90%
            if (pos < 20) {
                const d = 20 - pos;
                pos -= d;
            }
            else if (pos > 80) {
                const d = pos - 80;
                pos += d;
            }

            return _.clamp(pos, 0, 100);
        };

        const point = [ getBgPosFromPointValue(focusPoint[0]), getBgPosFromPointValue(focusPoint[1]) ];
        return point;
    }
    else {
        return [50, 50]; // default
    }
};


/**
 * Background-image url and background-position by FocusPoint.
 * For FocusPoint, param `imageInfo` is preferred, but deduced from item.ImageInfo or item.FocusPoint otherwise.
 */
export const getBackgroundImageStyle = function (imageSrc, item, imageInfo) {
    let style = '';
    if (imageSrc) {
        style += `background-image: url("${imageSrc}");`;

        let _imageInfo = imageInfo;
        if (!_imageInfo && item) {
            _imageInfo = getImageInfo(item, true); // FIXME: ImageInfo, CoverImageInfo, IngressImageInfo?
        }
        // take FocusPoint from imageInfo or item
        const focusPoint = _imageInfo?.FocusPoint || item?.FocusPoint;
        if (focusPoint) {
            const bgPos = getBackgroundPositionByFocusPoint(focusPoint);
            style += `background-position: ${bgPos[0]}% ${bgPos[1]}%;`;
        }
    }
    return style;
};


/**
 * Collection / Organization / Actor / Event banner.
 * Favourable to use with ImageBannerMixin.
 */
export const getBannerImageStyle = function (item, doEdit, useIngressImage, minHeight, imageAttrs) {
    if (!item) {
        return '';
    }

    const _imageAttrs = _.extend({resolution: {x: '100vw', y: 640}, missingImage: 'Redirect', cacheBust: doEdit}, imageAttrs);
    const imageSrc = useIngressImage ?
        getIngressImageSrc(item, _imageAttrs)
        : getCoverImageSrc(item, _imageAttrs);

    // apply FocusPoint
    let style = getBackgroundImageStyle(imageSrc, item);

    // min-height
    if (typeof minHeight === 'undefined') {
        minHeight = '400px';
    }
    if (minHeight) {
        const mhunit = (typeof minHeight === 'number' ? 'px' : '');
        style += `min-height: min(${minHeight}${mhunit}, 65vh);`;
    }

    return style;
};


export const getPaletteColorsBackgroundStyle = function (imageInfo, defaultColor) {
    let style = '';
    if (imageInfo) {
        // set background color
        if (imageInfo.PaletteColors?.length) {
            const palette = imageInfo.PaletteColors;
            if (palette.length === 1) {
                // one color
                style += `background-color: ${palette[0].Color};`;
            }
            else {
                // gradient
                let pct = 0;
                const colors = palette.reduce((acc, color) => {
                    // for sharp transitions, each color comes twice, eg. ", green 0%, green 50%, blue 50%, blue 100%" (ENL FTW)
                    // const pctStart = pct;
                    // pct += color.Cover * 100; // accumulate this
                    // return acc + `, ${color.Color} ${pctStart.toFixed(2)}%, ${color.Color} ${pct.toFixed(2)}%`;

                    // smoother gradient, eg. ", green 0%, blue 50%, gray 100%"
                    const pctStart = pct;
                    pct += color.Cover * 100; // accumulate this (value)
                    return acc + `, ${color.Color} ${pctStart.toFixed(2)}%`; // reduce function accumulator (string)
                }, '');
                const deg = _.sample([0, 45, 90, 145, 180]); // pick random angle
                style += `background: linear-gradient(${deg}deg${colors});`;
            }
        }
        else if (imageInfo.DominantColor) {
            style += `background-color: ${imageInfo.DominantColor};`;
        }
        else if (defaultColor) {
            style += `background-color: ${defaultColor};`;
        }
    }
    return style;
};


/**
 * Get Width, Height for styling image box to get sharp images without wasting bandwidth.
 *
 * ImageBox may often be used to style with these values, giving only resolution.x most of the time.
 * ImageInfo is used to calculate ratio to get the missing dimension.
 * Screen resolution is used to limit the maximum with optimised behaviour.
 *
 * In views and components, this usually should be a computed value, calculated before rendering.
 * For automatic detection, this would need to set a data- attribute for run-time to pick up on
 * and resolve the image source.
 *
 * With param `resolution`:
 *     x = 500       ; number ; the value will be used, (missing) y is calculated from ratio
 *     x = 'auto'    ; string ; the value will likewise be used, same with y
 *     x = '100vw'   ; string ; vw and vh are detected and relative width and height and calculated from client innerWidth/Height
 *     x ?           ; falsy  ; show maximum resolution image for client screen, if also y is undefined
 *
 * For `resolution.y` values it behaves likewise.
 * If no resolution, or ImageInfo is found, returned values are 'inherit'.
 *
 * Param `step`, when true, will step up CanvasX to the nearest pre-rendered X resolution.
 *
 */
export const getImageWidthHeightOptimised = function (item, resolution, step) {
    if (!resolution) {
        resolution = {};
    }

    let width;
    let height;


    // number value is used as is
    if (typeof resolution.x === 'number') {
        width = resolution.x;
    }
    if (typeof resolution.y === 'number') {
        width = resolution.y;
    }


    // string value can be anything, except "vw", "vh" are parsed for numeric value
    if (typeof resolution.x === 'string') {
        const vp = getViewportResolution(resolution.x);
        if (vp.height) {
            width = vp.height;
        }
        else if (vp.width) {
            // add some leeway for margin to upscale image res
            width = vp.width + 90;
        }
        else {
            width = resolution.x; // plain string
        }
    }
    if (typeof resolution.y === 'string') {
        const vp = getViewportResolution(resolution.y);
        if (vp.height) {
            height = vp.height;
        }
        else if (vp.width) {
            height = vp.width;
        }
        else {
            height = resolution.y; // plain string
        }
    }


    // calculate missing height or width by ratio
    const ratio = getImageAspectRatio(item);
    if (ratio) {
        if (typeof width === 'number' && typeof height === 'undefined') {
            height = width / ratio;
        }
        else if (typeof width === 'undefined' && typeof height === 'number') {
            width = height * ratio;
        }
    }


    // max width should not exceed client display resolution.
    // limit width and height to client innerWidth/Height
    if (typeof width === 'number' && width > (innerWidth - 105)) {
        width = innerWidth;
        height = width / ratio;
    }
    else if (typeof height === 'number' && height > innerHeight) {
        height = innerHeight;
        width = height * ratio;
    }


    // maximum resolution image for client screen
    if (typeof width === 'undefined' && typeof height === 'undefined') {
        width = getCanvasXStep(innerWidth);
        height = width / ratio;
    }
    else if (typeof width === 'undefined') {
        width = '100%'; // height (non-numeric) is set, width was not
    }
    else if (typeof height === 'undefined') {
        height = 'inherit'; // width (non-numeric) is set, height was not
    }


    // limit to CanvasX steps
    if (typeof width === 'number') {
        width = getCanvasXStep(width);
        if (typeof height === 'number') {
            height = width / ratio;
        }
    }
    else if (typeof height === 'number') {
        // pre-rendered images are for CanvasX, so this is calculated a bit differently
        height = getCanvasXStep(height * ratio) / ratio;
        width = height * ratio;
    }


    // round to integer
    if (typeof width === 'number') {
        width = Math.round(width);
    }
    if (typeof height === 'number') {
        height = Math.round(height);
    }


    return { width, height };
};


/**
 * Get style for image using width and height from `getImageWidthHeightOptimised`.
 */
export const getImageWidthHeightOptimisedStyle = function (item, resolution) {
    let { width, height } = getImageWidthHeightOptimised(item, resolution, true);

    if (typeof width === 'number') {
        width = width + 'px';
    }
    if (typeof height === 'number') {
        height = height + 'px';
    }

    return `width: ${width}; height: ${height};`;
};
